export default __webpack_public_path__ + "static/media/step_1_dont_1.e25e867d.jpg";